import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetPostPollActionType {
  Reset = 'postPoll/resetPostPoll',
}

export type TResetPostPoll = ITypedReduxAction<EResetPostPollActionType.Reset>;
